// extracted by mini-css-extract-plugin
export default {"button":"FluentMixinButton-module__button__OE_b9"};